// スタイリッシュホーム共通 JS（PC メガメニューホバー / 外部リンク）

const MEGA_MENU_CLOSE_DELAY = 180; // サブメニューへ移動する猶予（ms）
const MEGA_MENU_DESKTOP_QUERY = '(hover: hover) and (pointer: fine) and (min-width: 1000px)';

let megaMenuCloseTimer = null;
let megaMenuHoverRoot = null;

const isMegaMenuDesktop = () => window.matchMedia(MEGA_MENU_DESKTOP_QUERY).matches;

const clearMegaMenuCloseTimer = () => {
  if (megaMenuCloseTimer) {
    clearTimeout(megaMenuCloseTimer);
    megaMenuCloseTimer = null;
  }
};

const getMegaMenuItems = () => document.querySelectorAll('details[id^="Details-HeaderMenu-"]');

const closeMegaMenu = (item) => {
  if (!item) return;
  item.removeAttribute('open');
};

const closeMegaMenus = (except) => {
  getMegaMenuItems().forEach((item) => {
    if (item !== except) {
      closeMegaMenu(item);
    }
  });
};

const openMegaMenu = (item) => {
  if (!item || !isMegaMenuDesktop()) return;
  clearMegaMenuCloseTimer();
  closeMegaMenus(item);
  item.setAttribute('open', '');
};

const scheduleMegaMenuClose = () => {
  clearMegaMenuCloseTimer();
  megaMenuCloseTimer = setTimeout(() => {
    closeMegaMenus();
    megaMenuCloseTimer = null;
  }, MEGA_MENU_CLOSE_DELAY);
};

const isMegaMenuHoverTarget = (node) => {
  if (!node || !(node instanceof Node)) return false;
  return Boolean(node.closest?.('details[id^="Details-HeaderMenu-"]') || node.closest?.('.cm-mega-menu__content'));
};

const handleMegaMenuPointerOver = (event) => {
  if (!isMegaMenuDesktop()) return;

  const details = event.target.closest?.('details[id^="Details-HeaderMenu-"]');
  if (!details) return;

  openMegaMenu(details);
};

const handleMegaMenuPointerOut = (event) => {
  if (!isMegaMenuDesktop()) return;
  // 別メニュー／パネル内へ移動したときは閉じない
  if (isMegaMenuHoverTarget(event.relatedTarget)) return;
  scheduleMegaMenuClose();
};

const initMegaMenuHover = () => {
  const hoverRoot = document.querySelector('.header-wrapper');
  if (!hoverRoot) return;

  // テーマエディタでヘッダー DOM が差し替わったときリスナーを付け直す
  if (megaMenuHoverRoot !== hoverRoot) {
    megaMenuHoverRoot?.removeEventListener('pointerover', handleMegaMenuPointerOver);
    megaMenuHoverRoot?.removeEventListener('pointerout', handleMegaMenuPointerOut);
    megaMenuHoverRoot = hoverRoot;
    hoverRoot.addEventListener('pointerover', handleMegaMenuPointerOver);
    hoverRoot.addEventListener('pointerout', handleMegaMenuPointerOut);
  }

  getMegaMenuItems().forEach((item) => {
    if (item.dataset.cmMegaMenuBound === 'true') return;
    item.dataset.cmMegaMenuBound = 'true';

    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && item.hasAttribute('open')) {
        clearMegaMenuCloseTimer();
        closeMegaMenu(item);
        item.querySelector('summary')?.focus();
      }
    });
  });
};

const initCmCommon = () => {
  initMegaMenuHover();

  const links = document.querySelectorAll('a[href]');

  links.forEach((link) => {
    const href = link.getAttribute('href') || '';

    if (href.startsWith('#') || href.startsWith('tel:') || href.startsWith('mailto:') || href.startsWith('javascript:')) {
      return;
    }

    if (link.hostname && link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noopener';
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmCommon);
} else {
  initCmCommon();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target?.querySelector?.('details[id^="Details-HeaderMenu-"]')) {
    initMegaMenuHover();
  }
});
